import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { withStyles } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import StarBorderSharpIcon from "@material-ui/icons/StarBorderSharp";
import StarSharpIcon from "@material-ui/icons/StarSharp";
import ToggleButton from '@material-ui/lab/ToggleButton';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

// Style
import styles from "./styles";

class StarPopover extends Component {
  state = {
    open: false,
    anchorEl: null
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleStarSelect = (starsNum, index) => {
    this.handleClose();
    this.props.onClose(starsNum, index);
  };

  handleOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  renderStars(starsNum, index) {
    let stars = [];

    for (let i = 0; i < 5; i++) {
      if (i < starsNum) {
        stars.push(
          <IconButton key={"key" + index + i} onClick={() => this.handleStarSelect(i + 1, index)}>
            <StarSharpIcon />
          </IconButton>
        );
      } else {
        stars.push(
          <IconButton key={"key" + index + i} onClick={() => this.handleStarSelect(i + 1, index)}>
            <StarBorderSharpIcon />
          </IconButton>
        );
      }
    }
    return stars;
  }

  render() {
    const { classes, stars, index } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    return (
      <React.Fragment>
        <Tooltip placement="top" title="Rank Similarity">
          <ToggleButton selected={stars>0} className={classes.actionButton} variant="outlined" onClick={this.handleOpen}>
            {stars == 0 ? (
              <StarBorderSharpIcon className={classes.feedbackIcons} />
            ) : (
              <StarSharpIcon className={classes.feedbackIconActive} />
            )}
          </ToggleButton>
        </Tooltip>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          {this.renderStars(stars, index)}
        </Popover>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}
StarPopover = connect(
  mapStateToProps,
  mapDispatchToProps
)(StarPopover);

export default withStyles(styles)(StarPopover);
